import {Paper, Grid} from '@material-ui/core';
import {isLoading, toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import Loading from 'Shared/components/Loading';
import 'Users/components/UserRecovery/PasswordReset/PasswordReset.sass';
import PassResetForm from 'Users/components/UserRecovery/PasswordReset/PasswordResetForm';
import PassResetSuccessful from 'Users/components/UserRecovery/PasswordReset/PasswordResetSuccessful';
import {getPasswordResetRequestQuestions} from 'Users/ducks/passwordRecovery';
import {IndependentAgentProfile} from 'Users/models/IndependentAgentProfile';
import {PasswordUpdate} from 'Users/models/PasswordResetForm';
import {UserRouteConstants} from 'Users/Routes';

const PasswordReset = () => {
  const dispatch = useDispatch();
  const match = useRouteMatch<{requestKey: string}>();
  const {passwordResetRequest, passwordUpdate: passwordResetForm} = useSelector(
    (state: ReducerState) => state.user.passwordRecovery
  );

  useEffect(() => {
    dispatch(getPasswordResetRequestQuestions(match.params.requestKey));
  }, [dispatch, match.params.requestKey]);

  const renderForm = (agentProfile: IndependentAgentProfile) =>
    PasswordUpdate.match({
      Entry: update => (
        <PassResetForm
          requestKey={match.params.requestKey}
          passwordResetForm={update.form}
          agentProfile={agentProfile}
        />
      ),
      Saving: () => <Loading />,
      Complete: () => <PassResetSuccessful />,
    })(passwordResetForm);

  return pipe(
    passwordResetRequest,
    toEither,
    E.fold(
      async => (isLoading(async) ? <Loading /> : <Redirect to={UserRouteConstants.PASSWORD_RESET_REQUEST_EXPIRED} />),
      agentProfile => (
        <div className="password-reset">
          <Grid container xs={12} sm={8} md={6} lg={4}>
            <Paper className="password-reset__card">{renderForm(agentProfile)}</Paper>
          </Grid>
        </div>
      )
    )
  );
};

export default PasswordReset;
